module.exports = __webpack_public_path__ + "img/bap.13a783b0.png";